import {useRecoilValue} from "recoil";
import * as departmentApi from "../api/departmentApi/departmentApi";
import {ResponseList} from "../models/clientModels/interfaces/Response";
import {EQDepartment, initialDepartmentListParams} from "../models/serverModels/EQDepartment";
import {useGetQuery} from "./useQueryHooks";
import {tokenSelector} from "../Recoil/Atom/authState";

export const useDepartmentList = () => {
  const tokenState = useRecoilValue(tokenSelector);

  const {
    data: departmentList,
    isLoading,
    isFetching,
  } = useGetQuery<ResponseList<EQDepartment>>({
    key: "departmentList",
    api: () => departmentApi.getList({...initialDepartmentListParams, token: tokenState}),
    options: {
      onError: (error) => console.error(error),
    },
  });
  return {departmentList, isLoading, isFetching};
};
